import { render, staticRenderFns } from "./topRetails.vue?vue&type=template&id=0dcfbb69&"
import script from "./topRetails.vue?vue&type=script&lang=js&"
export * from "./topRetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports